import React from 'react';
import { useTranslation } from 'react-i18next';

// Paso 3 — Tarifas / Coberturas. Precios editables. Los ítems opcionales (ej.
// abono mensual pádel) arrancan colapsados: se muestran como botón "+ Agregar"
// hasta que el usuario los activa. También permite agregar coberturas custom.
function StepPricing({ state, errors, onChange }) {
  const { t } = useTranslation();
  const coverages = state.coverages || [];

  const setPrice = (idx, value) => {
    const next = coverages.map((c, i) =>
      i === idx ? { ...c, priceArs: value === '' ? '' : Number(value) } : c
    );
    onChange(next);
  };

  const setName = (idx, name) => {
    onChange(coverages.map((c, i) => (i === idx ? { ...c, name } : c)));
  };

  // Activa una cobertura opcional colapsada (priceArs null → '').
  const enableOptional = (idx) => {
    onChange(coverages.map((c, i) => (i === idx ? { ...c, priceArs: '' } : c)));
  };

  // Colapsa de nuevo (o elimina custom).
  const disableOrRemove = (idx) => {
    const c = coverages[idx];
    if (c.custom) {
      onChange(coverages.filter((_, i) => i !== idx));
    } else {
      onChange(coverages.map((x, i) => (i === idx ? { ...x, priceArs: null } : x)));
    }
  };

  const addCustom = () => {
    onChange([
      ...coverages,
      { key: `custom_${coverages.length}`, name: '', priceArs: '', custom: true },
    ]);
  };

  const collapsedOptionals = coverages
    .map((c, idx) => ({ c, idx }))
    .filter(({ c }) => c.optional && (c.priceArs === null || c.priceArs === undefined));

  const activeCoverages = coverages
    .map((c, idx) => ({ c, idx }))
    .filter(({ c }) => !(c.optional && (c.priceArs === null || c.priceArs === undefined)));

  return (
    <div className="sw-step">
      <h2 className="sw-step-title">
        {t('setupWizard.step3.title', {
          orgName: state.org.name || t('setupWizard.step2.yourBusiness', 'tu negocio'),
          defaultValue: 'Tarifas de {{orgName}}',
        })}
      </h2>

      <div className="sw-coverage-cards">
        {activeCoverages.map(({ c, idx }) => (
          <div key={c.key} className="sw-coverage-card">
            <div className="sw-coverage-head">
              {c.custom ? (
                <input
                  type="text"
                  className="sw-input sw-coverage-name-input"
                  value={c.name}
                  onChange={(e) => setName(idx, e.target.value)}
                  placeholder={t('setupWizard.step3.customName', 'Nombre de la cobertura')}
                />
              ) : (
                <span className="sw-coverage-name">{c.name}</span>
              )}
              {(c.optional || c.custom) && (
                <button
                  type="button"
                  className="btn btn-ghost btn-sm sw-icon-btn"
                  onClick={() => disableOrRemove(idx)}
                  aria-label={t('setupWizard.step3.remove', 'Quitar')}
                  title={t('setupWizard.step3.remove', 'Quitar')}
                >
                  <span className="material-icons">close</span>
                </button>
              )}
            </div>
            <label className="sw-coverage-price">
              <span className="sw-price-prefix">ARS</span>
              <input
                type="number"
                min="0"
                inputMode="numeric"
                className="sw-input"
                value={c.priceArs === null || c.priceArs === undefined ? '' : c.priceArs}
                onChange={(e) => setPrice(idx, e.target.value)}
                placeholder="0"
              />
            </label>
          </div>
        ))}
      </div>

      {collapsedOptionals.map(({ c, idx }) => (
        <button
          key={c.key}
          type="button"
          className="btn btn-secondary btn-sm sw-add-optional"
          onClick={() => enableOptional(idx)}
        >
          <span className="material-icons">add</span>
          {t('setupWizard.step3.addOptional', { name: c.name, defaultValue: 'Agregar {{name}}' })}
        </button>
      ))}

      <button type="button" className="btn btn-secondary btn-sm sw-add-optional" onClick={addCustom}>
        <span className="material-icons">add</span>
        {t('setupWizard.step3.addCustom', 'Agregar cobertura custom')}
      </button>

      {errors.coverages && (
        <p className="sw-error">
          {t('setupWizard.errors.priceRequired', 'Completá el precio de cada tarifa activa')}
        </p>
      )}

      <p className="sw-hint">
        {t(
          'setupWizard.step3.note',
          'Podrás ajustar precios por profesional desde la sección Coberturas.'
        )}
      </p>
    </div>
  );
}

export default StepPricing;
